import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=0604720a&scoped=true&"
import script from "./LineChart.vue?vue&type=script&lang=js&"
export * from "./LineChart.vue?vue&type=script&lang=js&"
import style0 from "./LineChart.vue?vue&type=style&index=0&id=0604720a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604720a",
  null
  
)

export default component.exports